"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function DeliverablesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const deliverables = ["Quiet support when nerves kick in", "Sydney wedding photographer who keeps it calm", "Sydney wedding videographer who captures feeling", "Natural wedding couple portraits, no performance", "Warm direction without constant posing", "Room for real laughter and tears", "Family dynamics handled with experienced care", "Vows and speeches captured clearly", "A wedding timeline that bends, not breaks", "Story-first coverage across photo and film"];
  return <section ref={ref} className="relative overflow-hidden bg-background py-16 px-6 md:py-24">
      <div className="container mx-auto max-w-7xl">
        <div className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="mb-12 text-center">
            <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">
              What You'll Receive
            </h2>
            <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
              A comprehensive collection crafted to preserve your wedding story
            </p>
          </div>

          <div className="grid gap-8 lg:grid-cols-[2fr_3fr]">
            {}
            <Card className="border-border bg-muted/50 shadow-soft backdrop-blur-sm">
              <CardContent className="space-y-4 p-8">
                {deliverables.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-3 transition-all duration-300 ease-out" style={{
                transitionDelay: isVisible ? `${i * 20}ms` : "0ms",
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateX(0)" : "translateX(-1rem)"
              }}>
                    <CheckCircle className="text-primary-active mt-0.5 h-5 w-5 flex-shrink-0" />
                    <p className="text-foreground leading-relaxed">{item}</p>
                  </div>)}
              </CardContent>
            </Card>

            {}
            <div className="transition-all duration-700 ease-out" style={{
            transitionDelay: isVisible ? "200ms" : "0ms",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(1.5rem)"
          }}>
              <Card className="overflow-hidden border-border shadow-medium">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_mrhx5jbe.png" alt="Wedding deliverables showcase" className="h-full w-full object-cover transition-transform duration-500 ease-out hover:scale-105" />
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}